module.exports = __webpack_public_path__ + "img/Ellipse12.cb96128b.svg";